    <p-table [value]="users"
             [paginator]="false"
             [style]="{'margin-top':'10px'}"
             selectionMode="multiple"
             [(selection)]="assignedUsers"
    >
      <ng-template pTemplate="header">
        <tr [ngStyle]="{'white-space': 'nowrap'}">
          <th style="width: 3em; padding: 0.5rem;"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
          <th>Name</th>
          <th>Email</th>
          <th>Status</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <p-tableCheckbox [value]="item"></p-tableCheckbox>
          </td>
          <td>{{getFullName(item)}}</td>
          <td>{{item.emailAddress}}</td>
          <td></td>
        </tr>
      </ng-template>
    </p-table>
    <div style="margin-top: 20px;" class="controls">
      <button mat-raised-button (click)="invite()">Save Changes</button>
      <button mat-raised-button (click)="close()">Cancel</button>
    </div>
